import * as React from 'react'
import { clsx } from 'clsx'

import styles from './Badge.module.css'

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  /**
   * Size of the badge
   * @default medium
   */
  size?: 'small' | 'medium' | 'large'
  /**
   * Variant of the badge
   * @default neutral
   */
  variant?:
    | 'neutral'
    | 'light'
    | 'brand'
    | 'brand-subtle'
    | 'warning'
    | 'brand-xsubtle'
    | 'success'
    | 'beta'
  /**
   * Contents of the badge
   */
  children: React.ReactNode
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    {
      size = 'medium',
      variant = 'neutral',
      children,
      className,
      ...props
    }: BadgeProps,
    forwardedRef,
  ) => {
    return (
      <span
        ref={forwardedRef}
        className={clsx(
          styles.badge,
          size !== 'medium' && styles[size],
          variant !== 'neutral' && styles[variant],
          className,
        )}
        {...props}
      >
        {children}
      </span>
    )
  },
)

Badge.displayName = 'Badge'

export { Badge }
export type { BadgeProps }
